import { z } from "zod";
import { isHistoricFileReference, type HistoricFileReference } from "@/lib/camunda/form-file-values";
import { isAllowedDocumentFile, MAX_FILE_SIZE } from "./multi-file-validation";

export const documentVersionSchema = z.object({
  file: z.union([
    z.instanceof(File).refine((file) => file.size > 0 && file.size <= MAX_FILE_SIZE && isAllowedDocumentFile(file), "El documento debe ser PDF, Word o Excel y no superar 5 MB"),
    z.custom<HistoricFileReference>(isHistoricFileReference),
  ]).nullish(),
  historicReference: z.custom<HistoricFileReference>(isHistoricFileReference).optional(),
  tipo: z.string(),
  documentId: z.string().optional(),
  documentTitle: z.string().optional(),
  fileVariableName: z.string().optional(),
  filename: z.string().optional(),
  persisted: z.boolean().optional().default(false),
  revision: z.number().int().positive().optional(),
  notes: z.string().optional(),
});

export type DocumentVersion = z.infer<typeof documentVersionSchema>;
